import axios from "@/lib/axios";

export type GetResourceLibraryRequestParams = {
  companyId: string;
};

export type ResourceLibraryOwner = {
  id: string;
  name: string;
};

export type GetResourceLibraryResponse = {
  id: string;
  name: string;
  accessType: string;
  directoryName: string;
  owner: ResourceLibraryOwner;
};

export const getResourceLibrary = (params: GetResourceLibraryRequestParams) =>
  axios
    .get<GetResourceLibraryResponse>(
      `/v1/companies/${params.companyId}/resource-libraries`,
    )
    .then((res) => res.data);
